export default "__VITE_ASSET__B5$AOGRr__"